// N11 Kategori Seçimi penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.n11CategorySelection';

export const inventoryN11CategorySelectionGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Ürün N11\'e hangi kategoriyle gönderilir?'),
  intro: t(`${G}.intro`, 'Bu pencerede stoktaki ürününüzü N11\'e göndermeden önce N11 kategorisini ve kargo şablonunu seçersiniz. Kategori seçimi zorunludur.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve gönderilecek ürün'),
    body: t(`${G}.regions.body`, 'Kategori ve kargo şablonu'),
    footer: t(`${G}.regions.footer`, 'İptal / N11\'e Gönder'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Gönderilecek ürünü kontrol edin'),
      text: t(`${G}.s1.text`, 'Üstteki kutuda "Gönderilecek Ürün" adı, stok kodu ve satış fiyatı görünür.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Kategoriyi adım adım seçin'),
      text: t(`${G}.s2.text`, 'N11 kategorileri katmanlıdır. "N11 Kategorisi Seçin" listesinden başlayın; seçim son seviye bir kategoriye ulaşınca tamamlanır.'),
      tips: [
        t(`${G}.s2.tip1`, '1. Ana kategorilerden başlayın.'),
        t(`${G}.s2.tip2`, '2. Bir kategori seçtiğinizde alt kategorileri görünür.'),
        t(`${G}.s2.tip3`, '3. 📁 alt kategorisi olan, 📄 son seviye kategoridir.'),
        t(`${G}.s2.tip4`, '4. Listenin altındaki satır kaç kategorinin bulunduğu seviyede olduğunu ya da yüklendiğini gösterir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Kategori yolu ve arama'),
      text: t(`${G}.s3.text`, '"Kategori Yolu" satırı nerede olduğunuzu gösterir; bir üst kategoriye tıklayarak geri gidebilir, "🏠 Ana Kategoriler" ile en başa dönebilirsiniz. Seçilen son kategori ✅ ile görünür ve altında Kategori ID yazar.'),
      tips: [
        t(`${G}.s3.tip1`, '"Kategori Ara" ile tüm kategorilerde arama yapabilirsiniz (en az 2 karakter, Enter veya büyüteç).'),
        t(`${G}.s3.tip2`, '"Temizle" aramayı ve seçimi sıfırlayıp ana kategorilere döner.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Kargo şablonunu seçin'),
      text: t(`${G}.s4.text`, 'Kargo şablonu, N11 satıcı panelinizdeki "Hesabım > Teslimat Bilgilerim" bölümünden oluşturduğunuz kargo şablonunun adıdır. Kaydettiğiniz N11 şablonları listelenir; varsayılan şablon otomatik seçilir, istediğinizi değiştirebilirsiniz.'),
      tips: [
        t(`${G}.s4.tip1`, 'Henüz kargo şablonu eklenmemişse sistem varsayılanı BAREM kullanılır. Yeni şablonları stok ekranındaki "Kargo Şablonları" seçeneğinden ekleyebilirsiniz.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. N11\'e gönderin'),
      text: t(`${G}.s5.text`, '"N11\'e Gönder" düğmesi bir kategori seçilince açılır. Gönderim başarılı olursa pencere kapanır; hata olursa pencere açık kalır.'),
    },
  ],
});
